import React from 'react'
import Newsletter from './NewsLetter';
import GetInTouch from './GetInTouch';
import Footer from './Footer';
import careerImage1 from '../assets/careerimage1.png'
import JobOpenings from './JobOpenings';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

const Career = () => {
  return (
    <div>
         <section className="py-5 text-start" style={{ backgroundColor: 'rgb(4,180,228)', height:'60vh' }}>
      <div className="container">
        <div className="row align-items-center">
          {/* Left Text Section */}
          <div className="col-md-6 text-white">
            <h1 className="fw-bold display-4 mb-3">Career</h1>
            <p className="fs-4 mb-4">
              Creative Work. Good Environment. Learning Opportunities
            </p>
            <a href='#jobOpen'><button
              className="btn btn-light fw-semibold px-4 py-2"
            //   data-bs-toggle="modal"
            //   data-bs-target="#getInTouchModal" // Optional: hook to modal
            >
              Start your journey today!
            </button></a>
          </div>

          {/* Right Image Section */}
          <div className="col-md-6 text-center mt-4 mt-md-0">
            <img
              src={careerImage1}
              alt="Career Illustration"
              className="img-fluid"
              style={{ maxHeight: '350px' }}
            />
          </div>
        </div>
      </div>
    </section>
    <JobOpenings/>
     {/* <Newsletter/> */}
     <GetInTouch/>
     <Footer/>
    </div>
  )
}

export default Career;
